import React from "react";
import { FaBarcode } from "react-icons/fa";
const ScanAsset = ({ isVerified,verifyModalOpen }) => {
  return (
     <div className="container fluid">
      {isVerified ? (
        <div className="mt-3">verified</div>
      ) : (
        <div className="text-center mt-3">
          <p className="text-small">
            Please verify to access scanning features.
          </p>
          <button onClick={verifyModalOpen} className="btn btn-outline-primary">Verify</button>
        </div>
      )}
    </div>
  );
};

export default ScanAsset;
